import { Tabs, Tab, Box } from "@mui/material";
import { useState } from "react";
import CloneDashboard from "./CloneDashboard";
import CreateDashboard from "./CreateDashboard";
import DashboardList from "./DashboardList";
import EditDashboard from "./EditDashboard";

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

function CustomTabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
}

function a11yProps(index: number) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}

interface ISelectedDashboardState {
	_id: string;
	name: string;
}

const DashboardSettings = () => {
	const [value, setValue] = useState(0);
	const [selectedDashboard, setSelectedDashboard] =
		useState<ISelectedDashboardState | null>(null);

	const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};

	return (
		<div>
			<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
				<Tabs
					value={value}
					onChange={handleChange}
					aria-label="basic tabs example"
				>
					<Tab label="Dashboard List" {...a11yProps(0)} />
					<Tab label="Create Dashboard" {...a11yProps(1)} />
					{selectedDashboard && (
						<Tab label="Clone Dashboard" {...a11yProps(2)} />
					)}
					{selectedDashboard && (
						<Tab label="Edit Dashboard" {...a11yProps(3)} />
					)}
				</Tabs>
			</Box>
			<CustomTabPanel value={value} index={0}>
				<DashboardList
					value={selectedDashboard}
					onChange={(val: ISelectedDashboardState) =>
						setSelectedDashboard(val)
					}
				/>
			</CustomTabPanel>
			<CustomTabPanel value={value} index={1}>
				<CreateDashboard />
			</CustomTabPanel>
			<CustomTabPanel value={value} index={2}>
				{selectedDashboard && <CloneDashboard {...selectedDashboard} />}
			</CustomTabPanel>
			<CustomTabPanel value={value} index={3}>
				{selectedDashboard && <EditDashboard {...selectedDashboard} />}
			</CustomTabPanel>
		</div>
	);
};

export default DashboardSettings;
